module.exports = __webpack_public_path__ + "img/bongabong-circulation.c6e02507.jpg";